import { render } from "./ShipmentList_item_group.vue?vue&type=template&id=ebdb673c&scoped=true"
import script from "./ShipmentList_item_group.vue?vue&type=script&lang=js"
export * from "./ShipmentList_item_group.vue?vue&type=script&lang=js"

import "./ShipmentList_item_group.vue?vue&type=style&index=0&id=ebdb673c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdb673c"]])

export default __exports__